module.exports = __webpack_public_path__ + "static/media/promo.d8d33ffe.svg";